module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_3.65254ef0.png";